/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IDIAOracleV2, IDIAOracleV2Interface } from "../IDIAOracleV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "getValue",
    outputs: [
      {
        internalType: "uint128",
        name: "latestPrice",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "timestampOfLatestPrice",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IDIAOracleV2__factory {
  static readonly abi = _abi;
  static createInterface(): IDIAOracleV2Interface {
    return new utils.Interface(_abi) as IDIAOracleV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IDIAOracleV2 {
    return new Contract(address, _abi, signerOrProvider) as IDIAOracleV2;
  }
}
